import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from './useAuth';

interface Props {
  children: React.ReactNode;
}

/**
 * Protected route component that redirects to login if not authenticated.
 */
export const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const { isLoading, isAuthenticated, login } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    // Redirect to Razor Pages login with return URL
    const returnUrl = location.pathname + location.search;
    login(returnUrl);
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  return <>{children}</>;
};
